/**
 * Websocket reducer
 * @namespace websocket_reducer
 * @category Redux
 * @subcategory Reducers
 */
// eslint-disable-next-line
const websocket_reducer = {};
//used for the namespace in the documentation

/**
 * The initial shared state
 * @memberof websocket_reducer
 */
const initState = {
  avl: {
    trams: {},
    trolleysAndEBuses: {},
    buses: {},
  },
  hobo: {},
  spark: {},
};

/**
 * Redux static data reducer
 * @category Redux
 * @subcategory Reducers
 * @memberof websocket_reducer
 * @function websocketDataReducer
 * @param {object} state the state of the reducer
 * @param {object} action the actions for the reducer
 */

const websocketReducer = (state = initState, action) => {
  switch (action.type) {
    case "SET_WEBSOCKET_AVL_DATA":
      return {
        ...state,
        avl: action.payload,
      };
    case "SET_WEBSOCKET_HOBO_DATA":
      return {
        ...state,
        hobo: action.payload,
      };
    case "SET_WEBSOCKET_SPARK_DATA":
      return {
        ...state,
        spark: action.payload,
      };
    default:
      return state;
  }
};

export default websocketReducer;
